import BackendAPI from '~/api/BackendClient/BackendAPI'

class CultureOperationsAPI extends BackendAPI {
  updateCultureStatus = ({
    culture_extid,
    status_extid,
    wells,
  }: {
    culture_extid: string
    status_extid: string
    wells: string[]
  }) => {
    return this.client.POST(
      '/api/culture-operations/{culture_extid}/status/{status_extid}',
      {
        params: {
          path: {
            culture_extid,
            status_extid,
          },
        },
        body: wells,
      },
    )
  }
}

export default CultureOperationsAPI
